import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { CaravanCoverage } from "Store/interfaces/products/coverage";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";
import { CaravanProductDetailsFormValues } from "./ProductDetails/interfaces";
import { CaravanProductIntroFormValues } from "./ProductIntro/interfaces";
import { CaravanProductPriceFormValues } from "./ProductPrice/interfaces";
import { DEFAULT_SELECTED_COVERAGES } from "./constants";
import { CaravanProductPriceRequestInfo } from "./interface";

export const getDefaultCoverage = (
  coverages: CoveragePriceCalculation[],
): CaravanCoverage => {
  const keys = coverages.map((coverage) => coverage[0] as CaravanCoverage);

  const defaultCoverage = keys.find((cur) =>
    DEFAULT_SELECTED_COVERAGES.includes(cur),
  );

  if (!isDefined(defaultCoverage)) {
    throw Error(
      `Unable to locate a valid default coverage, available coverages are ${String(
        keys,
      )}`,
    );
  }

  return defaultCoverage;
};

export function mapFormToPriceReq(
  intro: Required<CaravanProductIntroFormValues>,
  details: CaravanProductDetailsFormValues,
  price: Partial<CaravanProductPriceFormValues>,
): CaravanProductPriceRequestInfo {
  return {
    ...intro,
    ...details,
    ...price,

    // intro
    registrationYear: Number(intro.registrationYear),

    // details
    permanentPlace: formBooleanToBoolean(details.fixedPlace),
    injuries: Number(details.injuries),
    injuryYear:
      details.injuries !== DamageRecentYears.NONE
        ? Number(details.injuryYear)
        : null,

    // price
    movables: Number(price.movables),
  };
}
